// Class: motion.easing._Sine.SineEaseIn

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var SineEaseIn = function() {
}

// Meta

SineEaseIn.__name__ = ["motion","easing","_Sine","SineEaseIn"];
SineEaseIn.__isInterface__ = false;
SineEaseIn.__interfaces__ = [(motion_easing_IEasing().default)];
SineEaseIn.prototype = {
	calculate: function(k) {
		return 1 - Math.cos(k * (Math.PI / 2));
	},
	ease: function(t,b,c,d) {
		return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	}
};
SineEaseIn.prototype.__class__ = SineEaseIn.prototype.constructor = $hxClasses["motion.easing._Sine.SineEaseIn"] = SineEaseIn;

// Init



// Statics




// Export

exports.default = SineEaseIn;